export const refreshUserToken = async (endpoint, callback, navigateTo) => {
  let refreshToken = localStorage.getItem("refreshToken");

  try {
    let res = await fetch(endpoint + `/?refreshToken_=${refreshToken}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      } /* access token is provide even thou it expired (backend compatibility)*/,
    });
    console.log(res.status);
    if (res.status === 200) {
      let { accessToken, refreshToken } = await res.json();
      console.log(accessToken, refreshToken);
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      console.log(callback);

      if (callback) callback();
      return true;
    } else {
      /* go to login */
      console.log(res.status, res.message);
      console.log("refresh token expired login again");
      navigateTo ? navigateTo("/sign-in") : (window.location.href = "/sign-in");
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};
